import PropTypes from 'prop-types';
import { Card } from 'react-bootstrap';
import fallbackAvatar from '@/assets/avatar-fallback.svg';
import '../Team.css';

function TeamCard({
    name,
    title,
    university,
    timeline,
    avatarUrl,
    profileUrl,
}) {
    const imgSrc = avatarUrl || fallbackAvatar;
    const imgAlt = avatarUrl ? name : `No profile picture for ${name}`;

    return (
        <Card className="h-100 border-0 shadow-sm text-center">
            <Card.Body>
                <img
                    src={imgSrc}
                    alt={imgAlt}
                    className="team-avatar rounded-circle mb-3"
                />
                <Card.Title className="h5 mb-1">
                    {profileUrl ? (
                        <a
                            href={profileUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            {name}
                        </a>
                    ) : (
                        name
                    )}
                </Card.Title>
                {title && <div className="text-muted">{title}</div>}
                {university && <div className="small">{university}</div>}
                {timeline && <div className="small text-muted">{timeline}</div>}
            </Card.Body>
        </Card>
    );
}

TeamCard.propTypes = {
    name: PropTypes.string.isRequired,
    title: PropTypes.string,
    university: PropTypes.string,
    timeline: PropTypes.string,
    avatarUrl: PropTypes.string,
    profileUrl: PropTypes.string,
};

export default TeamCard;
